export default __webpack_public_path__ + "static/media/settings-bold.f26de6e0.svg";